import React from 'react';
import { FaPencilAlt, FaPaintBrush, FaUserAlt, FaImages, FaBullseye, FaHeart, FaClock, FaHandshake } from 'react-icons/fa';
import './About.css';

const About = () => {
  return (
    <section id="about" className="section about">
      <div className="container">
        <div className="section-title">
          <h2>About Chandan</h2>
          <p>Passionate artist dedicated to creating meaningful connections through art</p>
        </div>
        
        <div className="about-content">
          <div className="about-text">
            <div className="about-intro">
              <h3>My Story</h3>
              <p>
                Hello! I'm Chandan, a passionate sketch artist with over 5 years of experience 
                in creating beautiful, meaningful artwork. My journey began with a simple pencil 
                and a dream to capture the world's beauty through art.
              </p>
              <p>
                What started as a hobby has evolved into a deep passion for creating custom 
                portraits, illustrations, and sketches that tell stories and preserve precious 
                memories. Every piece I create is infused with emotion, attention to detail, 
                and a personal touch that makes it truly special.
              </p>
            </div>
            
            <div className="about-skills">
              <h3>My Expertise</h3>
              <div className="skills-grid">
                <div className="skill-item">
                  <div className="skill-icon"><FaPencilAlt /></div>
                  <h4>Pencil Sketches</h4>
                  <p>Detailed graphite and charcoal drawings</p>
                </div>
                <div className="skill-item">
                  <div className="skill-icon"><FaPaintBrush /></div>
                  <h4>Digital Art</h4>
                  <p>Modern digital illustrations and designs</p>
                </div>
                <div className="skill-item">
                  <div className="skill-icon"><FaUserAlt /></div>
                  <h4>Portraits</h4>
                  <p>Custom portraits from photos</p>
                </div>
                <div className="skill-item">
                  <div className="skill-icon"><FaImages /></div>
                  <h4>Illustrations</h4>
                  <p>Creative illustrations and concept art</p>
                </div>
              </div>
            </div>
          </div>
          
          <div className="about-image">
            <div className="image-placeholder">
              <div className="artist-avatar">
                <img src="/profile.png" alt="Chandan - Professional Sketch Artist" className="profile-image" />
              </div>
              <h4>Chandan</h4>
              <p>Professional Sketch Artist</p>
            </div>
          </div>
        </div>
        
        <div className="about-values">
          <div className="value-item">
            <div className="value-icon"><FaBullseye /></div>
            <h4>Quality First</h4>
            <p>Every piece is crafted with meticulous attention to detail and quality</p>
          </div>
          <div className="value-item">
            <div className="value-icon"><FaHeart /></div>
            <h4>Personal Touch</h4>
            <p>Each artwork is personalized to capture your unique story and vision</p>
          </div>
          <div className="value-item">
            <div className="value-icon"><FaClock /></div>
            <h4>Timely Delivery</h4>
            <p>Committed to delivering your artwork on time, every time</p>
          </div>
          <div className="value-item">
            <div className="value-icon"><FaHandshake /></div>
            <h4>Client Satisfaction</h4>
            <p>Your happiness is my priority - unlimited revisions until you're satisfied</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
